import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { CrearTareaComponent } from "./crear-tarea/crear-tarea.component";
import { CrearTareaDialog } from "./crear-tarea/crear-tarea-dialog/crear-tarea-dialog.component";
import { TareaComponent } from "./tarea/tarea.component";
import { EditarTareaDialog } from "./editar-tarea/editar-tarea-dialog/editar-tarea-dialog.component";
import { EliminarTareaDialog } from "./eliminar-tarea/eliminar-tarea-dialog/eliminar-tarea-dialog.component";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { ListarTareasComponent } from "./listar-tareas/listar-tareas.component";
import { ListadoTareasComponent } from "./listar-tareas/listado-tareas/listado-tareas.component";
import { DetalleTareaComponent } from "./detalle-tarea/detalle-tarea.component";
import { EditarTareaComponent } from "./editar-tarea/editar-tarea.component";
import { EliminarTareaComponent } from "./eliminar-tarea/eliminar-tarea.component";
import { RouterModule } from "@angular/router";
import { VerTareasComponent } from "./ver-tareas/ver-tareas.component";
import { TareaResponsablesModule } from "./tarea-responsables/tarea-responsables.module";
import { MaterialModule } from "../../components/material/material.module";
import { VolverModule } from "../../components/volver/volver.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        RouterModule,
        TareaResponsablesModule,
        MaterialModule,
        VolverModule,
    ],
    declarations: [
        CrearTareaComponent,
        CrearTareaDialog,
        TareaComponent,
        EditarTareaDialog,
        EliminarTareaDialog,
        ListarTareasComponent,
        ListadoTareasComponent,
        DetalleTareaComponent,
        EditarTareaComponent,
        EliminarTareaComponent,
        VerTareasComponent
    ],
    providers: [
    ],
    entryComponents: [
        CrearTareaDialog,
        EditarTareaDialog,
        EliminarTareaDialog
    ],
    exports: [
        CrearTareaComponent,
        DetalleTareaComponent,
        EditarTareaComponent,
        EliminarTareaComponent,
        ListarTareasComponent,
        TareaComponent,
        VerTareasComponent,
    ]
})
export class TareaModule { }